import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Input
} from '@angular/core';

@Directive({
  selector: '[lm-layout-util]'
})
export class LMLayoutUtilDirective implements AfterViewChecked {
  // Used to hide element if value is empty
  @Input() hideWhiteSpace: boolean;

  constructor(public elementRef: ElementRef) {}

  ngAfterViewChecked(): void {
    if (this.hideWhiteSpace) {
      this._fixWhiteSpace();
    }
  }

  /** White space use cases
   *  LMCLIENT-23529
   *  LMCLIENT-23565
   *  LMCLIENT-20919
   *  LMCLIENT-23719
   */
  private _fixWhiteSpace() {
    const nativeElement = this.elementRef.nativeElement;
    const whiteSpaceElement = nativeElement.querySelectorAll('.hide-white-space');

    if (whiteSpaceElement.length === 0) {
      return;
    }

    const value = whiteSpaceElement[0].innerText;

    // LMCLIENT-37057
    // Check if contents is IFRAME
    // Ignore if true
    if (whiteSpaceElement[0]?.children[0]?.nodeName === 'IFRAME') {
      return;
    }

    this.toggleElementVisibility(value);
  }

  private toggleElementVisibility(value: string) {
    const previousSibling = this.elementRef.nativeElement.previousElementSibling;
    let labelIsNoLabel = false;

    if (previousSibling) {
      labelIsNoLabel = this.elementRef.nativeElement.previousElementSibling.classList.contains('lm-no-label');
    }

    if (value.trim().length === 0 && labelIsNoLabel) {
      this.elementRef.nativeElement.style.display = 'none';
    } else {
      // LMCLIENT-36954
      // Removing display none via empty string should be a safer approach vs setting to 'block'.
      // This way it will revert the element back to its original state when it becomes visible again.
      // And we won't have to worry about it overriding other rules. Like inline-block and inline-flex for example.
      this.elementRef.nativeElement.style.display = '';
    }
  }

  /**
   *  Get the width of host
   */
  public getWidth(): string {
    if (this.elementRef && this.elementRef.nativeElement) {
      const width = this.elementRef.nativeElement.offsetWidth;
      return width === 0 ? '' : this.elementRef.nativeElement.offsetWidth;
    } else {
      return null;
    }
  }

  /**
   * Get the width of host's parent
   */
  public getParentWidth(): string {
    if (this.elementRef &&
      this.elementRef.nativeElement &&
      this.elementRef.nativeElement.parentElement
    ) {
      const width = this.elementRef.nativeElement.parentElement.offsetWidth;
      return width === 0 ? '' : this.elementRef.nativeElement.parentElement.offsetWidth;
    } else {
      return null;
    }
  }

}
